import * as React from 'react';
import DialogBase from '../Shared/DialogBase';
import { Box, Button, Grid2, IconButton, Stack, TextField } from '@mui/material';
import { useApi } from '../Api/useApi';
import { CreateProjectRequest, FileParameter, ProjectsRycApiClient } from '../Api/ApiServer';
import { RemoveCircle } from '@mui/icons-material';

export interface ICreateProjectDialogProps {
    open: boolean;
    onClose: (refresh: boolean, projectId?: number) => void;
}

export default function CreateProjectDialog(props: ICreateProjectDialogProps) {
    const { open, onClose } = props;
    const [currentState, setCurrentState] = React.useState(0);
    const [projectName, setProjectName] = React.useState('');
    const [selectedFiles, setSelectedFiles] = React.useState<FileList | null>(null);
    const [projectId, setProjectId] = React.useState<number | null>(null);
    const { authorizedApi } = useApi(ProjectsRycApiClient);
    const canNext = React.useMemo(() => {
        if (currentState === 0)
            return projectName.length > 0;
        if (currentState === 1)
            return selectedFiles !== null;
    }, [currentState, projectName, selectedFiles]);
    const canFinish = React.useMemo(() => {
        if (currentState === 0)
            return projectName.length > 0;
        else
            return true;
    }, [currentState, projectName]);
    const createProject = React.useCallback(async (closeAfter: boolean) => {
        if (authorizedApi) {
            const projectId = await authorizedApi.createProject(new CreateProjectRequest({ name: projectName }));
            if (projectId?.projectId) {
                setProjectId(projectId.projectId);
                if (closeAfter)
                    onClose(true, projectId.projectId);
            }

        }

    }, [authorizedApi, projectName, onClose]);
    const onFilesSelected = React.useCallback(async (files: FileList, closeAfter: boolean) => {
        console.log(files, { data: files[0], fileName: files[0].name });
        if (projectId)
            await authorizedApi?.uploadProjectImage({ data: files.item(0), fileName: files[0].name } as FileParameter, projectId);
        if (closeAfter)
            onClose(true);
    }, [projectId, authorizedApi, onClose]);
    const next = React.useCallback(() => {
        if (currentState === 0)
            createProject(false);
        if (currentState === 1 && selectedFiles)
            onFilesSelected(selectedFiles, false);
        if (canNext)
            setCurrentState(currentState + 1);
    }, [canNext, currentState, createProject, onFilesSelected, selectedFiles]);
    const finish = React.useCallback(() => {
        if (currentState === 0)
            createProject(true);
        if (currentState === 1 && selectedFiles)
            onFilesSelected(selectedFiles, true);
    }, [onFilesSelected, createProject, currentState, selectedFiles]);
    const inputRef = React.useRef<HTMLInputElement>(null);
    return (
        <DialogBase dialogActions={
            <Stack direction='row' justifyContent='flex-end' spacing={2}>
                {/* <Button onClick={next} disabled={!canNext}>další</Button> */}
                <Button onClick={finish} disabled={!canFinish}>dokončit</Button>
            </Stack>
        } title='Nový projekt' onClose={onClose} open={open}>
            {currentState === 0 && <Grid2 mt={2} width={350} container>
                <Grid2 size={{ xs: 12 }}>
                    <TextField value={projectName} onChange={(e) => { setProjectName(e.currentTarget.value) }} label='Název projektu' fullWidth />
                </Grid2>
            </Grid2>}
            {currentState === 1 && (
                <Box display='flex' minWidth={350} justifyContent='center' alignItems='center' minHeight={250}>
                    {selectedFiles === null && (
                        <Button
                            onClick={() => {
                                inputRef.current?.click();
                            }}
                            variant='contained'
                            size='small'
                        >
                            Vybrat obrázek
                        </Button>
                    )}
                    {selectedFiles !== null && (
                        <Stack alignItems='center' >
                            <img
                                src={URL.createObjectURL(selectedFiles[0])}
                                alt={selectedFiles[0].name}
                                style={{ maxWidth: '320px', marginRight: '10px' }}
                            />
                            {selectedFiles[0].name}
                            <IconButton
                                onClick={() => {
                                    setSelectedFiles(null);
                                }}
                            >
                                <RemoveCircle color='error' />
                            </IconButton>
                        </Stack>
                    )}
                    <input
                        type='file'
                        ref={inputRef}
                        style={{ display: 'none' }}
                        onChange={(e) => {
                            if (e.target.files) setSelectedFiles(e.target.files);
                            e.target.files = null;
                        }}
                    />
                </Box>
            )}
        </DialogBase>
    );
}
